import React, {PureComponent} from "react";
import Dict from 'dict-lib';
import BUtils from "../../../../../utilities/BaseUtilities";
import {Grid, Row, InputGroup, FormGroup, FormControl, Button, Col} from 'react-bootstrap';
import stylesLexemeSenses from "../../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css";
import {LexemePageContext} from "../../../LexemePageContext";
import {LexemeSenses} from "./LexemeSenses";
import {AdministrationUtilities} from "../../../../../administration/AdministrationHelper";
import {userService} from "../../../../../_redux/authentication/services/user.services";
import {LexemeUtilities} from "../../../editor/LexemeHelper";
import ReactTooltip from 'react-tooltip';
import FontAwesome from "react-fontawesome";
import stylesSCTree from "../../../../../dict-components/tree/SCTree.module.css";
import ReactDom from "react-dom";
import {SenseEncyclopedicInfos} from "../../../editor/senses/SenseComponents";

export class LexemeEncyclopedicInfos extends PureComponent {

    constructor(props) {
        super(props);

        this.isLogged = userService.isLogged();

        this.state = {
            html: '',
            hover: false,
            editing: false,
            tinyLoaded: false,
            bibliography: ''
        };

        this.isEditable = false;
        this._launchEdit = this._launchEdit.bind(this);
        this._closeEdit = this._closeEdit.bind(this);
        this._resetTiny = this._resetTiny.bind(this);
    }

    componentDidMount() {
        this._performLoadHtml();
    }

    _performLoadHtml() {
        try {
            var contextDescrLanguage = this.context.descrLanguage;
            this.isEditable = LexemeUtilities.isPageEditable(this)
            var code = typeof contextDescrLanguage !== 'undefined' ? contextDescrLanguage : AdministrationUtilities.getDescriptionLanguageByContext(this.context);

            if (typeof this.props.item.encyclopedic_infos !== 'undefined') {
                const urls = [
                    '/senses/getEncyclopedicInfos/' + this.props.item.encyclopedic_infos.id + '/' + code + '/',
                    typeof this.props.item.topic !== 'undefined' ? '/service/topics/getTopicBibliography/' + this.props.item.topic.id + '/' : ''
                ];

                Promise.all(urls.map(url => Dict.call(url))).then(result => {
                    const html = result[0];
                    const bibliography = result[1].bibliography;
                    this.setState({html, bibliography}, () => {
                        if (document.getElementById('ency_edit_' + this.props.item.ids).innerHTML === '')
                            this._loadTiny();
                        var references = document.getElementsByClassName('lexeme-references__is-encyclopedic--true');
                        if (references.length > 0) {
                            references[0].style.visibility = 'visible';
                        }
                    })
                })
            } else {
                this._loadTiny();
            }
        } catch (e) {
            this.setState({html: 'errore di recupero testo'});
        }
    }

    /*shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.html !== nextState.html || this.state.hover !== nextState.hover || this.state.editing !== nextState.editing || this.state.tinyLoaded !== nextState.tinyLoaded;
    }*/

    /*shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.html !== nextState.html || this.state.hover !== nextState.hover || this.state.editing !== nextState.editing || this.state.tinyLoaded !== nextState.tinyLoaded || this.props.item.topic !== nextProps.item.topic;
    }*/

    componentDidUpdate(prevProps, prevState) {
        if (typeof this.props.item.encyclopedic_infos === 'undefined') {
            this.setState({html: ''}, () => {
                this._resetTiny('')
            });
        //} else if (((this.state.bibliography === '' || typeof this.state.bibliography === 'undefined') && typeof this.props.item.topic !== 'undefined') || prevProps.item.topic.id !== this.props.item.topic.id) {
        } else if (prevProps.item.topic !== this.props.item.topic) {
            this._performLoadHtml();
        }
    }

    _loadTiny() {
        //ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        ReactDom.render(<SenseEncyclopedicInfos item={this.props.item}
                                                context={this.context}
                                                html={this.state.html}
                                                callbackParent={(newState, html) => {
                                                    this._closeEdit(html);
                                                }}
                                                callbackParentSaveOnly={(newState, html) => {
                                                    if (html !== null)
                                                        this._resetTiny(html);
                                                }}

        />, document.getElementById('ency_edit_' + this.props.item.ids), () => {
            this.setState({tinyLoaded: true});
        });
    }

    _resetTiny(html) {
        ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        this.setState({html}, () => {
            this._loadTiny();
        })
        //this._performLoadHtml();
    }

    _launchEdit() {
        ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        this.setState({editing: true}, () => {
            this._loadTiny();
        });
    }

    _closeEdit(html) {
        //ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        this.setState({editing: false, hover: false}, () => {
            if (html !== null)
                this._resetTiny(html);
        });
    }

    render() {
        return <>
            {this.state.tinyLoaded && (this.props.item.encyclopedic_infos === 'undefined' || this.state.html === '') && !this.state.editing ?
                <Button onClick={() => {
                    this.setState({editing: true});
                }}>Aggiungi informazione enciclopedica</Button> : ''}
            {typeof this.props.item.topic === 'undefined' || !this.state.tinyLoaded ? "" :
                <>
                    <div
                        className={BUtils.joinClasses(stylesLexemeSenses['senseItemTopic'], stylesLexemeSenses['senseEncyItemTopic'])}
                        data-tip data-for='encyclopedic_infos-tooltip-description'
                    >{this.props.item.topic.extendedUniqueDescription}</div>
                    <ReactTooltip id='encyclopedic_infos-tooltip-description' type='dark' delayShow={150}>
                        <div dangerouslySetInnerHTML={{__html: this.state.bibliography}}/>
                    </ReactTooltip></>}
            <div id={'ency_edit_' + this.props.item.ids}
                 className={BUtils.joinClasses(stylesLexemeSenses['encyclopedic_infos_editor_container'], stylesLexemeSenses['encyclopedic_infos_editor_container__' + this.state.editing])}/>
            {!this.state.editing && this.isLogged ? <div
                className={BUtils.joinClasses(stylesLexemeSenses['encyclopedic_infos_container__pencil'], stylesLexemeSenses['encyclopedic_infos_container__pencil__' + this.state.hover])}>
                <FontAwesome name={'pencil'} style={{fontSize: '20px', color: '#c1c1c1'}}/>
            </div> : ''}
            {!this.state.editing ? <div
                onMouseOver={() => {
                    this.setState({hover: true})
                }}
                onMouseOut={() => {
                    this.setState({hover: false})
                }}

                onClick={() => {
                    if (this.isLogged)
                        this._launchEdit();
                }}
                className={BUtils.joinClasses(stylesLexemeSenses['encyclopedic_infos_container'], stylesLexemeSenses['encyclopedic_infos_container_editor__' + this.isEditable])}
                dangerouslySetInnerHTML={{__html: this.state.html}}/> : ''}
        </>
    }
}

LexemeEncyclopedicInfos.contextType = LexemePageContext;